/**
 * @desc version util
 * @date 2020-01-03
 * */

const VersionUtil = {

  // 各jsbridge指令支持版本列表
  versionList: {
    cameraToggle: {
      androidVersion: '1.7.5',
      iosVersion: '1.7.5',
    },
    shareFast: {
      androidVersion: '1.7.3',
      iosVersion: '1.7.3',
    },
    cameraPermission: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    cameraOpen: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    cameraClose: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    shoot: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    albumPermission: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    albumOpen: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    recordInit: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    recordStart: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
    recordStop: {
      androidVersion: '1.7.2',
      iosVersion: '1.7.2',
    },
  },

  /**
     * 比较版本大小
     * @method _$versionCompare
     * @param {String} v1 当前版本
     * @param {String} v2 指定版本
     * @return {number} 1:> 0:= -1:<
     */
  _$versionCompare: (v1: string, v2: string) => {
    const v1parts = v1.split('.');
    const v2parts = v2.split('.');

    for (let i = 0; i < v1parts.length; i += 1) {
      if (v1parts[i] > v2parts[i]) {
        return 1;
      }
      if (v1parts[i] < v2parts[i]) {
        return -1;
      }
    }

    return 0;
  },
};

export default VersionUtil;
